import { Skeleton, Text, Bullet } from '@costar-ui/components';
import React from 'react';

var Designation = function Designation(props) {
  var hqLocation = props.hqLocation,
    companyType = props.companyType,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'designation' : _props$testId,
    isLoading = props.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25",
    className: "csg-tw-skeleton-designation wrap-anywhere"
  }) : hqLocation && companyType ? /*#__PURE__*/React.createElement(Text, {
    variant: "text-16",
    testId: testId,
    className: "gap-1"
  }, hqLocation, ' ', /*#__PURE__*/React.createElement(Bullet, {
    size: "sm",
    className: "inline-flex w-auto pl-0.5 pr-1"
  }), companyType) : hqLocation ? /*#__PURE__*/React.createElement(Text, {
    variant: "text-16",
    testId: "".concat(testId, "-hq-location")
  }, hqLocation) : companyType ? /*#__PURE__*/React.createElement(Text, {
    variant: "text-16",
    testId: "".concat(testId, "-company-type")
  }, companyType) : null;
};

export { Designation };
//# sourceMappingURL=designation.esm.js.map
